/** Shown on login and dashboard home areas only (not on report card header). */
export const SHARED_SCHOOL_MOTTO =
  'Training a generation of Godly leaders who are sought after their wisdom';

/** Printed below the report card body (footer). */
export const REPORT_CARD_ACADEMIC_MOTTO = 'An Academic Attitude is a Positive Attitude';
